import Utils from './utils';
import Notices from './notices';

class AjaxButton {
  constructor(element, notices) {
    this.button = element;
    this.button.addEventListener('click', (e) => this.submit(e));
    this.ajax = this.button.dataset.ajax;
    this.confirm = this.button.dataset.confirm || 'yes';
    this.ajaxData = this.button.dataset.ajaxData ? JSON.parse(this.button.dataset.ajaxData) : {};

    this.isLoading = false;

    this.notices = notices;
  }

  getConfirmationMessage() {
    switch (this.ajax) {
      case 'user-logout':
        return 'Are you sure you want to log out?';
      case 'user-delete-account':
        return 'Are you sure you want to delete your account and all of your data? Your account will be deactivated immediately and you will be logged out.';
      case 'user-checkout':
        return 'Are you sure you want to proceed to checkout?';
      case 'user-cancel-entry':
        return 'Are you sure you want to cancel and delete this entry?';
      default:
        return 'Are you sure?';
    }
  }

  getConfirmation() {
    return this.confirm === 'yes' ? confirm(this.getConfirmationMessage()) : true;
  }

  submit(e) {
    e.preventDefault();

    if (this.isLoading) {
      return;
    }

    this.notices.hideNotice();

    if (!this.getConfirmation()) {
      return;
    }

    // const beforeEvent = this.beforeRequestEvent();

    // console.log(beforeEvent);

    // if (!beforeEvent) {
    //   return;
    // }

    this.button.classList.add('is-loading');
    this.isLoading = true;

    const endpoint = this.ajax;

    Utils.ajaxRequest(endpoint, this.ajaxData).then((response) => {
      if (response?.redirect) {
        window.location.href = response.redirect;
        return;
      }

      this.button.classList.remove('is-loading');
      this.isLoading = false;

      if (response?.ajaxData) {
        this.ajaxData = {
          ...this.ajaxData,
          ...response.ajaxData,
        };
      }

      if (response?.message) {
        this.notices.showNotice({
          message: response.message,
          type: 'success',
          dismissDelay: endpoint === 'user-cancel-entry' ? 3000 : -1,
          scrollTo: false,
        });
      }

      const event = new CustomEvent('kmAwardsAjaxButtonResponse', {
        detail: {
          endpoint,
          response,
          button: this.button,
        },
      });
      document.dispatchEvent(event);

      if (response.data?.reload || response?.reload) {
        if (response.reloadDelay) {
          setTimeout(() => {
            window.location.reload();
          }, response.reloadDelay);
        } else {
          window.location.reload();
        }
      }
    });
  }

  beforeRequestEvent() {
    const event = new CustomEvent('kmAwardsAjaxButtonBeforeRequest', {
      detail: {
        endpoint: this.ajax,
      },
    });

    document.dispatchEvent(event);
  }
}

export default () => {
  const buttons = document.querySelectorAll('.js-km-awards-btn[data-ajax]');

  if (buttons.length) {
    buttons.forEach((button) => new AjaxButton(button, new Notices('inline')));
  }
};
